var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTakeAway = function SvgTakeAway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12a6 6 0 1 0-6-6 6 6 0 0 0 6 6Zm4-6a4 4 0 1 1-4-4 4 4 0 0 1 4 4Zm8 16a1.959 1.959 0 0 1-2 2H2a1.959 1.959 0 0 1-2-2c0-2 2-8 12-8s12 6 12 8Zm-2-.008a5.344 5.344 0 0 0-1.664-3.328C19.032 17.36 16.578 16 12 16s-7.032 1.36-8.336 2.664A5.355 5.355 0 0 0 2 21.992Z"
  })));
};
export default SvgTakeAway;